module.exports = __webpack_public_path__ + "operace-nosu_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_2_before.jpg
// module id = 1132
// module chunks = 0